export default "__VITE_ASSET__CZQnMqLA__"